<template>
	<div class="page">
		<top-header></top-header>
		<b-container fluid>
			<b-row class="mt-3 mb-2">
				<b-col class="col-md-6 col-sm-6 col-xs-6 text-left">
					<h3>Manage Artwork Fields <b-breadcrumb :items="breadcrumb"></b-breadcrumb></h3>
				</b-col>
				<b-col class="col-md-6 col-sm-6 col-xs-6 text-right">
					<b-button variant="dark" pill class="mr-2" @click="showAddModal()"><b-icon class="mr-2" icon="plus" aria-hidden="true"></b-icon>Add Artwork Field</b-button>
				</b-col>
			</b-row>
		</b-container>
		<b-container fluid>
			<b-row>
				<b-col class="col-md-12 col-sm-12 col-xs-12">
					<div class="container-box">
						<b-row class="px-3 pt-3">
							<b-col lg="12">
								<b-table show-empty sticky-header small striped outlined id="my-table" stacked="md" :items="records" :fields="fields">
									<template v-slot:cell(status)="row">
										<b-badge pill variant="danger" v-if="row.value == 0">INACTIVE</b-badge>
										<b-badge pill variant="success" v-else>ACTIVE</b-badge>
									</template>
                                    <template v-slot:cell(defcolor)="row">
                                        <div v-if="row.item.type=='fill'" :style="'width:25px;height:25px;border-radius:5px;background-color:#'+row.item.defcolor"></div>
                                        <div v-else>
                                            <div class="mr-2" :style="'float:left;width:25px;height:25px;border-radius:5px;background-color:#'+row.item.color1"></div>
                                            <div :style="'float:left;width:25px;height:25px;border-radius:5px;background-color:#'+row.item.color2"></div>
                                        </div>
                                    </template>
									<template v-slot:cell(actions)="row">
										<b-button pill variant="primary" class="mr-1" @click="showUpdateModal(row.item, row.index, $event.target)" size="sm"><b-icon class="mr-2" icon="pencil" aria-hidden="true"></b-icon>Edit</b-button>
										<b-button pill variant="danger" class="mr-1" @click="showDeleteModal(row.item)" size="sm"><b-icon class="mr-2" icon="trash" aria-hidden="true"></b-icon>Delete</b-button>
									</template>
								</b-table>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>

			
			<b-modal id="my-model" :title="(selectedItem.id > 0)?'Edit Artwork Field':'Add Artwork Field'" size="xl" ok-only @hidden="resetSelectedItem" @ok="modalSubmit">
                <b-container fluid>
					<b-row class="mb-1">
                        <b-col cols="4">
                            <form ref="form" @submit.stop.prevent="handleSubmit">
                                <b-row class="mb-3">
									<b-col cols="4" class="text-right"><label class="font-sm">Label Text</label></b-col>
									<b-col>
                                        <b-form-select v-model="selectedItem.step_id" size="sm" :options="productsteps">
                                            <!--<b-form-select-option v-for="item in productsteps" v-bind:key="item.id" :value="item.id" :disabled="item.parent == 0">{{item.title}}</b-form-select-option>-->
                                        </b-form-select>
                                    </b-col>
								</b-row>
                                <b-row class="mb-3">
									<b-col cols="4" class="text-right"><label class="font-sm">Upper Description</label></b-col>
									<b-col><b-form-textarea v-model="selectedItem.upper_desc" size="sm" rows="2" max-rows="6"></b-form-textarea></b-col>
								</b-row>
                                <b-row class="mb-3">
									<b-col cols="4" class="text-right"><label class="font-sm">Lower Description</label></b-col>
									<b-col><b-form-textarea v-model="selectedItem.lower_desc" size="sm" rows="2" max-rows="6"></b-form-textarea></b-col>
								</b-row>
                                 <b-row class="mb-3">
									<b-col cols="4" class="text-right"><label class="font-sm">Key</label></b-col>
									<b-col>
                                        <b-form-input v-model="selectedItem.key" size="sm"></b-form-input>
                                        <small>linked with other product color</small>
                                    </b-col>
								</b-row>
                                <b-row class="mb-3">
									<b-col cols="4" class="text-right"><label class="font-sm">Field ID</label></b-col>
									<b-col><b-form-input v-model="selectedItem.field_id" size="sm" required disabled></b-form-input></b-col>
								</b-row>
                                <b-row class="mb-3">
									<b-col cols="4" class="text-right"><label class="font-sm">Type</label></b-col>
									<b-col><b-form-select v-model="selectedItem.type" :options="field_options" size="sm" required></b-form-select></b-col>
								</b-row>
                                <b-row class="mb-3" v-if="selectedItem.type=='fill'">
									<b-col cols="4" class="text-right"><label class="font-sm">Default Color</label></b-col>
									<b-col>
                                        <b-form-select v-model="selectedItem.defcolor" size="sm">
                                            <b-form-select-option v-for="item in productcolors" v-bind:key="item.id" :value="item.hexcode">{{ item.title+'  ['+item.hexcode+']' }}</b-form-select-option>
                                        </b-form-select>
                                    </b-col>
								</b-row>
                                <b-row class="mb-3" v-if="selectedItem.type=='gradient'">
									<b-col cols="4" class="text-right"><label class="font-sm">Color 1</label></b-col>
									<b-col><b-form-select v-model="selectedItem.color1" :options="productcolors" size="sm"></b-form-select></b-col>
								</b-row>
                                <b-row class="mb-3" v-if="selectedItem.type=='gradient'">
									<b-col cols="4" class="text-right"><label class="font-sm">Color 2</label></b-col>
									<b-col><b-form-select v-model="selectedItem.color2" :options="productcolors" size="sm"></b-form-select></b-col>
								</b-row>
                                <b-row class="mb-3">
									<b-col cols="4" class="text-right"><label class="font-sm">Position</label></b-col>
									<b-col><b-form-input v-model="selectedItem.position" size="sm" placeholder="eq. 10"></b-form-input></b-col>
								</b-row>
                                <!--<b-row class="mb-3">
									<b-col cols="4" class="text-right"><label class="font-sm">Display</label></b-col>
									<b-col>
                                        <b-form-select v-model="selectedItem.display" size="sm" required>
                                            <b-form-select-option value="AUTO">Accordian</b-form-select-option>
                                            <b-form-select-option value="FIXED">Fixed</b-form-select-option>
                                        </b-form-select>
                                    </b-col>
								</b-row>-->
                                <b-row class="mb-3">
									<b-col cols="4" class="text-right"><label class="font-sm">Status</label></b-col>
									<b-col><b-form-select v-model="selectedItem.status" :options="$root.status_options" size="sm" required></b-form-select></b-col>
								</b-row>
                            </form>
                        </b-col>
                        <b-col cols="4">
                            <b-form-textarea v-model="svgdisplay" size="sm" rows="3" max-rows="6"></b-form-textarea>
                            <ul id="svgidsview">
                                
                            </ul>
                        </b-col>
                        <b-col cols="4">
                            <div class="w-100 bg-checked">
                                <b-img id="svgimage" src="" fluid alt="SVG image"></b-img>
                            </div>
                        </b-col>
					</b-row>
                </b-container>
				<template v-slot:modal-footer="{ ok, close }">
					<b-button size="sm" variant="danger" @click="close()">Cancel</b-button>
					<b-button size="sm" variant="success" @click="ok()">{{(selectedItem.id > 0)?'Update':'Submit'}}</b-button>
				</template>
			</b-modal>
		
		</b-container>
		<transition name="fade">
			<b-row v-if="loading" class="loading" style="position: absolute; top:0px; left:0px; right:0px; bottom:0px; z-index: 1000; background-color: rgba(0,0,0,0.4);" align-v="center" align-h="center">
				<b-spinner label="Busy" variant="light"></b-spinner>
			</b-row>
		</transition>
	</div>
	
</template>
<script>
import Header from "@/components/Header.vue";
export default {
	name: 'Devices',
	components: {
		"top-header": Header
	},
	mounted(){
		var self = this;
		Object.assign(self.selectedItem, self.emptyItem);
		this.initload();
	},
	data() {
		return{
            loading: true, 
            breadcrumb: [
				{
					text: 'Home',
					href: '/'
				},
				{
					text: 'Products',
					href: '/dyo/products'
                },
                {
					text: 'Selected Product',
					href: '/dyo/product//edit'
                },
                {
					text: 'Artworks',
					href: '/dyo/product//artworks'
				},
				{
					text: 'Fields',
					active: true
				}
			],
            thumbnailProps: { blank: false, width: 60, height: 60, class: 'm1' },
            artwork_image: [],
            artwork_art_file: [],
            artwork: '',
			recordUrl: this.$root.WEBAPI+'artworkfield-record',
			updateUrl: this.$root.WEBAPI+'artworkfield-update',
            deleteUrl: this.$root.WEBAPI+'artworkfield-delete',
            productsteps: [],
            records: [],
            svgdisplay: '',
            default_colors: [{ value: '#990000', text: 'Red' }, { value: '#009900', text: 'Green' }, { value: '#000099', text: 'Blue' }],
            field_options: [{value: 'fill', text: 'Fill'}, {value: 'gradient', text: 'Gradient'}],
			fields: [
				{ key: 'id', label: 'ID'},
				{ key: 'title', label: 'Title'},
                { key: 'key', label: 'Key' },
                { key: 'field_id', label: 'Field ID' },
                { key: 'type', label: 'Color Type' },
                { key: 'defcolor', label: ' Color', 
					formatter: (value, key, item) => {
						if(item.type == 'fill'){
							return item.defcolor;
						}else{
                            return item.color1+" | "+item.color2;
                        }
					},
				},
                { key: 'position', label: 'Position' },
				{ key: 'status', label: 'Status' },
				{ key: 'actions', label: 'Actions', 'extra': 1 }
			],
			selectedItem: {},
			emptyItem: {
				id: 0,
                title: '',
                field_id: '',
                description: '',
                key: '',
                type: 'fill',
				defcolor: '',
				position: 0,
                status: 1
            },
            svgdata: '',
		};
	},
	methods: {
		showAddModal(){
            this.selectedItem = Object.assign({}, this.emptyItem);

            this.selectedItem.id = new Date().getTime();
            this.selectedItem.display = 'AUTO';
            
            this.loadSVG();
			this.$root.$emit('bv::show::modal', 'my-model');
		},
		showUpdateModal(item, index, button) {
            this.selectedItem = Object.assign({}, item);
            
            this.loadSVG();
			
			this.$root.$emit('bv::show::modal', 'my-model', button)
		},
		showDeleteModal(item){
			var self = this;
			this.$bvModal.msgBoxConfirm('Please confirm that you want to delete artwork!.', {
				title: 'Please Confirm',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'YES',
				cancelTitle: 'NO',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			})
			.then(value => {
				if(value == true){
					self.axios.post(self.deleteUrl, {
						accesskey: self.$session.get('access_key'),
						delete_id: item.id
					})
					.then(function (response) {
						if(response.data.error == 0 || response.data.error == '0'){
							self.$bvToast.toast(response.data.message, {
								title: 'Delete',
								toaster: 'b-toaster-bottom-right',
								autoHideDelay: 5000,
								variant: 'warning',
								solid: true,
								appendToast: true
							});
							self.initload();
						}
						
					})
					.catch(function (error) {
						alert(error);
					});
				}else{
					//alert('no '+item.id);
				}
			})
			.catch(err => {
				// An error occurred
				console.log(err);
			})
		},
		modalSubmit(bvModalEvt){
			var self = this;
			self.loading = true;
            bvModalEvt.preventDefault();
            
            var submitUrl = self.updateUrl;

            var flag = false;
            for(var i=0; i<this.records.length; i++){
                if(this.records[i].id == self.selectedItem.id){
                    Object.assign(this.records[i], self.selectedItem);
                    console.log('DATA UPDATED!');
                    flag = true;
                }
            }
            if(!flag){
                this.records.push(Object.assign({}, self.selectedItem));
            }
            
			self.axios.post(submitUrl, {
                'data': self.records,
                'artwork_id': self.$route.params.artwork_id,
                'accesskey': self.$session.get('access_key')
            })
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.$bvModal.hide('my-model');
					self.$bvToast.toast(response.data.message, {
						title: 'Status',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'warning',
						solid: true,
						appendToast: true
                    });
                    self.loading = false;
					//self.initload();
				}
				
			})
			.catch(function (error) {
				alert(error);
			});
		},
		
		

		resetSelectedItem(){
			var self = this;
			self.selectedItem = Object.assign({}, self.emptyItem);
		},
		initload(){
			var self = this;
			
			self.axios.post(self.recordUrl, {
                accesskey: self.$session.get('access_key'),
                artwork_id: self.$route.params.artwork_id
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){                    
                    self.artwork = response.data.result.artwork;
                    
                    self.records = JSON.parse(response.data.result.artwork.field_data);
                    self.productsteps = response.data.result.steps;
                    self.productsteps.forEach(function(field){
                        if(field.parent != 0){
                            field.text = field.title;
                        }else{
                            field.html = '----- '+field.title+' -----';
                            field.disabled = true;
                        }
                        field.value = field.id;
                    });

                    self.productcolors = response.data.result.colors;

                    self.breadcrumb[2] = {text: self.artwork.product_name,	href: '/dyo/product/'+self.artwork.product_id+'/edit'};
                    self.breadcrumb[3] = {text: 'Artworks',	href: '/dyo/product/'+self.artwork.product_id+'/edit#artworks'};
					//self.records = data.fields;
					self.loading = false;
				}else if(response.data.error == 9){
					self.$root.forceLogout(response.data.message);
				}
				//setTimeout(self.initload, 1000*30);
			})
			.catch(function (error) {
				alert(error);
			});
			//alert('login '+self.email+" "+self.password);
        },
        loadSVG(){
            var self = this;
            var http = new XMLHttpRequest();
            http.open( 'GET', this.$root.MEDIAPATH+this.$session.get('user_info').uniq_id+'/products/'+this.artwork.product_id+'/artworks/'+this.artwork.art_file, true );
            http.onload = function() {
                let parser = new DOMParser()
                let svgdom = parser.parseFromString(this.response, "image/svg+xml");
                self.svgdata = svgdom;

                self.svgdisplay = this.response;
                
                /*
                var serializedSVG = new XMLSerializer().serializeToString(this.svgdata);
                var xmldata = 'data:image/svg+xml;base64,'+btoa(serializedSVG);
                document.getElementById("svgimage").src = xmldata;
                */
                
                self.getSvgIDs(self.svgdata, function(svgids){
                    console.log(svgids);
                    var node = document.getElementById("svgidsview");
                    self.buildTreeUI(svgids, node, 'CB');

                    var i,j = 0;
                    var current_id = '';

                    
                    // add click event listener
                    var toggler = document.getElementsByClassName("caret");
                    
                    
                    for (i = 0; i < toggler.length; i++) {
                        toggler[i].addEventListener("click", function() {
                            this.nextElementSibling.classList.toggle("active");
                            this.classList.toggle("caret-down");
                        });
                    }
                    
                    var svgcb = document.getElementsByClassName("svgcb");
                    
                    var serializedSVG = '';
                    var xmldata = '';
                    for (i = 0; i < svgcb.length; i++) {
                        svgcb[i].addEventListener("change", function() {
                            self.hideAllSvgID(self.svgdata, 'none');

                            var checkboxes = document.getElementsByName('svgattr');
                            var checked = [];
                            for (var i=0; i<checkboxes.length; i++) 
                            {
                                if (checkboxes[i].checked) 
                                {
                                    checked.push(checkboxes[i].value);
                                }
                            }
                            self.selectedItem.field_id = checked.join();
                            
                            var ids = this.id.split("_");
                            current_id = '';
                            for(j = 0; j<ids.length; j++){
                                current_id += ids[j];
                                if(this.checked){
                                    if(document.getElementById(current_id).getAttribute("data-id") != ""){
                                        self.svgdata.getElementById(document.getElementById(current_id).getAttribute("data-id")).style.display = 'block';
                                        self.svgdata.getElementById(document.getElementById(current_id).getAttribute("data-id")).setAttribute('fill', '#000000');
                                        self.svgdata.getElementById(document.getElementById(current_id).getAttribute("data-id")).setAttribute('style', 'fill:#000000');
                                        //self.selectedItem.field_id = document.getElementById(current_id).getAttribute("data-id");
                                    }
                                }else{
                                    /*if(document.getElementById(current_id).getAttribute("data-id") != ""){
                                        self.svgdata.getElementById(document.getElementById(current_id).getAttribute("data-id")).style.display = 'none';
                                    }*/
                                }
                                current_id += '_';
                            }
                            
                            serializedSVG = new XMLSerializer().serializeToString(self.svgdata);
                            xmldata = 'data:image/svg+xml;base64,'+btoa(serializedSVG);
                            document.getElementById("svgimage").src = xmldata;
                            
                        });
                    }
                    

                    // select field id
                    if(self.selectedItem.field_id != ''){
                        var inputs = document.getElementsByTagName("input");
                        self.hideAllSvgID(self.svgdata, 'none');
                        
                        for (i = 0; i < inputs.length; i++) {
                            var fieldids = self.selectedItem.field_id.split(',');
                            for(var k=0; k<fieldids.length; k++){
                                console.log(fieldids[k]+" "+inputs[i].getAttribute('data-id'));
                                if(fieldids[k] == inputs[i].getAttribute('data-id')){
                                    inputs[i].checked = true;
                                    
                                    var ids = inputs[i].id.split("_");
                                    current_id = '';

                                    

                                    for(j = 0; j<ids.length; j++){
                                        current_id += ids[j];

                                        if(j < ids.length-1){
                                            document.getElementById(current_id).parentElement.classList.add('caret-down');
                                            document.getElementById(current_id).parentElement.nextSibling.classList.add('active');
                                        }

                                        if(document.getElementById(current_id).getAttribute("data-id") != ""){
                                            self.svgdata.getElementById(document.getElementById(current_id).getAttribute("data-id")).style.display = 'block';
                                            self.svgdata.getElementById(document.getElementById(current_id).getAttribute("data-id")).setAttribute('fill', '#000000');
                                            self.svgdata.getElementById(document.getElementById(current_id).getAttribute("data-id")).setAttribute('style', 'fill:#000000');
                                            //self.selectedItem.field_id = document.getElementById(current_id).getAttribute("data-id");
                                        }
                                        
                                        //self.svgdata.getElementById(document.getElementById(current_id).getAttribute("data-id")).setAttribute('style', 'block');
                                        //self.svgdata.getElementById(document.getElementById(current_id).getAttribute("data-id")).style.display = 'block';
                                        //self.svgdata.getElementById(document.getElementById(current_id).getAttribute("data-id")).setAttribute('fill', '#000000');
                                        
                                        current_id += '_';
                                    }

                                    serializedSVG = new XMLSerializer().serializeToString(self.svgdata);
                                    xmldata = 'data:image/svg+xml;base64,'+btoa(serializedSVG);
                                    document.getElementById("svgimage").src = xmldata;
                                    break;
                                }
                            }
                            /*if(self.selectedItem.field_id.split(',').indexOf(inputs[i].getAttribute('data-id')) != -1){
                                break;
                            }*/
                        }
                    }else{
                        self.hideAllSvgID(self.svgdata, 'none');
                    
                        serializedSVG = new XMLSerializer().serializeToString(self.svgdata);
                        xmldata = 'data:image/svg+xml;base64,'+btoa(serializedSVG);
                        document.getElementById("svgimage").src = xmldata;
                    }
                });
            };
            http.send();
        },
        hideAllSvgID(svg, display){
            var childnodes = svg.childNodes;
            for(var _index=0; _index < childnodes.length; _index++){
                if((svg.childNodes[_index].tagName != undefined || svg.childNodes[_index].tagName == 'linearGradient' || svg.childNodes[_index].tagName == 'script')){
                    //var svg_id = svg.childNodes[_index].id;
                    if(svg.childNodes[_index].childNodes.length > 0){
                        this.hideAllSvgID(svg.childNodes[_index], display) ;
                    }
                    if(svg.childNodes[_index].id != '' ){
                        if(svg.childNodes[_index].style){
                            svg.childNodes[_index].style.display = display;
                        }else{
                            svg.childNodes[_index].setAttribute('style', 'display: none');
                        }
                    }
                }else{
                    //console.log(svg.childNodes[_index].tagName);
                }
            }
        },
        getSvgIDs(svg, callback){
            var svgids = new Array();
            var childnodes = svg.childNodes;
            console.log(svg.childNodes.length);
            for(var _index=0; _index < childnodes.length; _index++){
                console.log(svg.childNodes[_index].tagName);
                if(svg.childNodes[_index].tagName != undefined || svg.childNodes[_index].tagName == 'linearGradient'){
                    var svg_id = svg.childNodes[_index].id;
                   
                    if( svg.childNodes[_index].tagName != undefined ){
                        var o = new Object();
                        o.text = svg_id;
                        o.tagname = svg.childNodes[_index].tagName;
                        o.children = new Array();
                        console.log(">> "+svg.childNodes[_index].childNodes.length);
                        if(svg.childNodes[_index].childNodes.length > 0){
                            o.children = this.getSvgIDs(svg.childNodes[_index], '') ;
                        }
                        svgids.push(o);
                    }
                }
            }
            if(callback instanceof Function){
                callback(svgids);
            }
            return svgids;
        },
        buildTreeUI(a, parent, uid){
            for(var i = 0; i < a.length; i++){
                var node = document.createElement("li");
                
                var dnode = document.createElement("div");
                if(a[i].children.length > 0){
                    dnode.setAttribute('class', 'caret');
                }else{
                    dnode.setAttribute('class', 'no-caret');
                }
                /*var checkbox = document.createElement('input');
                checkbox.type = "checkbox"; 
                checkbox.setAttribute('class', 'svgcb');
                checkbox.name = "name"; 
                checkbox.value = "1";
                checkbox.id = uid+(i+1);		
                checkbox.setAttribute('data-id', a[i].text);*/
                
                
                var checkbox = document.createElement('input');
                checkbox.type = "checkbox"; 
                checkbox.setAttribute('class', 'svgcb');
                checkbox.name = "svgattr"; 
                checkbox.value = a[i].text;
                checkbox.id = uid+(i+1);
                checkbox.setAttribute('data-id', a[i].text);
                
                
                var lnode = document.createElement("label");
                lnode.htmlFor = uid+(i+1); 
                lnode.appendChild(document.createTextNode(a[i].tagname+'#'+a[i].text)); 
                dnode.appendChild(checkbox);
                dnode.appendChild(lnode);
                
                node.appendChild(dnode);
                if(a[i].children.length > 0){
                    console.log(a[i].children.length);
                    var ulnode = document.createElement("ul");
                    ulnode.setAttribute('class', 'nested');
                    node.appendChild(ulnode);
                    this.buildTreeUI(a[i].children, ulnode, uid+(i+1)+'_');
                }
                
                parent.appendChild(node);
            }
            return uid;
        },
        expandTag(){

        }
	}
}
</script>
